<app-action-selector *ngIf="actions.length > 0" [actions]="actions" (actionSelected)="onAction($event)"> </app-action-selector>
